import { render, staticRenderFns } from "./SimMenuLink.vue?vue&type=template&id=e3d98194&scoped=true&"
import script from "./SimMenuLink.vue?vue&type=script&lang=js&"
export * from "./SimMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d98194",
  null
  
)

export default component.exports